import React, { useState, FC, JSX } from 'react';
import { TabsProps, TabItem } from '../../types/components.d';

const Tabs: FC<TabsProps> = ({ 
  tabs, 
  defaultTab = 0, 
  onTabChange,
  variant = 'default',
  size = 'md',
  className = '' 
}): JSX.Element => {
  const [activeTab, setActiveTab] = useState<number>(defaultTab);

  const handleTabClick = (index: number): void => {
    setActiveTab(index);
    onTabChange && onTabChange(index, tabs[index]);
  };

  const variants = {
    default: {
      tab: 'text-gray-600 hover:text-primary-black border-b-2 border-transparent hover:border-primary-lightGreen',
      activeTab: 'text-primary-black border-b-2 border-primary-lightGreen',
      container: 'border-b border-gray-200',
    },
    pills: {
      tab: 'text-gray-600 hover:text-primary-black hover:bg-primary-teaGreen rounded-lg',
      activeTab: 'text-primary-black bg-primary-lightGreen rounded-lg',
      container: 'bg-gray-100 p-1 rounded-lg',
    },
    underline: {
      tab: 'text-gray-600 hover:text-primary-black border-b-2 border-transparent hover:border-gray-300',
      activeTab: 'text-primary-black border-b-2 border-primary-black',
      container: 'border-b border-gray-200',
    },
  };

  const sizes = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-3 text-base',
    lg: 'px-6 py-4 text-lg',
  };

  const currentVariant = variants[variant];

  return (
    <div className={className}>
      {/* Tab Headers */}
      <div className={`flex ${currentVariant.container}`}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => handleTabClick(index)}
            className={`${sizes[size]} font-medium transition-all duration-300 ${
              activeTab === index ? currentVariant.activeTab : currentVariant.tab
            }`}
          >
            {tab.icon && (
              <span className="mr-2">
                {tab.icon}
              </span>
            )}
            {tab.label}
            {tab.badge && (
              <span className="ml-2 px-2 py-1 bg-gray-200 text-gray-600 text-xs rounded-full">
                {tab.badge}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {tabs[activeTab]?.content}
      </div>
    </div>
  );
};

export default Tabs;
